import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import questions from './questions.json'
// import spot_the_not from '../public/spot_the_not.json'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'safety-is-personal',
  storage: localStorage
})

const initialState = () => {
  return {
    user: {},
    score: 0,
    categories: ['HHM', 'Claims', 'SRC', 'General Safety'],
    currentCategory: 'HHM',
    timerTime: 0,
    triviaQuestions: questions,
    correctPoints: 100,
    incorrectPoints: 18,
    skipPoints: 5
  }
}

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: initialState(),
  getters: {
    trivia: state => {
      return state.triviaQuestions.filter(triviaQuestion => triviaQuestion.category == state.currentCategory)
    },

    images: state => {
      return state.spotTheNotImages
    },

    triviaById: state => (id) => {
      return state.triviaQuestions.filter(triviaQuestion => triviaQuestion.id == id)
    },

    nextTriviaById: state => (id) => {
      let index = state.triviaQuestions.findIndex(triviaQuestion => triviaQuestion.id == id)
      return state.triviaQuestions[index + 1]
    },

    getCurrentCategory: state => {
      return state.currentCategory
    }
  },
  mutations: {
    saveUser (state, user) {
      state.user = user
    },

    updateCategory (state, category) {
      state.currentCategory = category
    },

    setTimer (state, time) {
      state.timerTime = time
    },

    updateTimer (state, time) {
      state.timerTime = state.timerTime -= parseInt(time)
    },

    resetState (state) {
      const s = initialState()
      //eslint-disable-next-line no-console
      console.log(s)
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },

    addPoints (state) {
      const addPoints = state.correctPoints
      
      state.score += addPoints
    },

    subtractPoints (state) {
      const subtractPoints = state.incorrectPoints
      
      state.score -= subtractPoints
    },

    subtractSkipPoints (state) {
      const subtractPoints = state.skipPoints
      
      state.score -= subtractPoints
    }
  },
  actions: {
    saveUser (context, user) {
      context.commit('saveUser', user)
    },

    updateCategory (context, category) {
      context.commit('updateCategory', category)
    },

    setTimer (context, time) {
      context.commit('setTimer', parseInt(time))
    },

    updateTimer (context, time) {
      context.commit('updateTimer', time)
    },

    resetState (context) {
      context.commit('resetState')
    },

    addPoints (context) {
      context.commit('addPoints')
    },

    subtractPoints (context) {
      context.commit('subtractPoints')
    },

    subtractSkipPoints (context) {
      context.commit('subtractSkipPoints')
    }
  }
})
